module.exports = __webpack_public_path__ + "static/media/P1050646-min.d30d5cd0.JPG";